export default "__VITE_ASSET__mHGKFuNO__"